import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { API_URL, getValFromLS, setValToLS, fmtCurrency } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import InputReadOnly from "../components/InputReadOnly";

import ContactsCallout from "./ContactsCallout";
import Form1 from "./Form1";
import Form2 from "./Form2";
import Form3 from "./Form3";
import Form4 from "./Form4";

import "./styles.css";

const FriendsDash = () => {
	const [names, setNames] = useState({
		form: 0,
		copied: false,
	});
	const [data, setData] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	let token = "";

	const history = useHistory();

	useEffect(() => {
		init();

		// eslint-disable-next-line
	}, []);

	const init = async () => {
		if (getValFromLS("friendsDash", true)) {
			token = getValFromLS("friendsDash", true);
		} else if (getValFromLS("friendsDash")) {
			token = getValFromLS("friendsDash");
		}

		const url = new URL(`${API_URL}/auth/friendsDashInit`);
		const params = {
			token,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setValToLS("friendsDash", token, true);
				setData((data) => ({ ...data, ...json }));
				setAlert({});
			} else {
				setAlert({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleCopy = (url) => {
		navigator.clipboard.writeText(url);
		handleUpdate("copied", true);

		setTimeout(handleResetCopy, 5000);
	};

	const handleResetCopy = () => {
		handleUpdate("copied", false);
	};

	const handleSignout = () => {
		setValToLS("friendsDash", null, true);
		setValToLS("friendsDash", null);
		history.push("/");
	};

	return (
		<div id="full-column">
			<Hdg section="Friendraising" />
			<>
				{alert.type ? (
					<Alert data={alert} />
				) : (
					<>
						<div className="top-grid">
							<div>
								<h3 style={{ marginTop: "0" }}>
									<i className="fa fa-user-circle-o" /> &nbsp;
									{`${data.fname}’s Dashboard for ${data.charity}`}
								</h3>

								<p>
									Thank you for your support of Champions fore Charity
									initiative and we look forward to assisting you in your
									friendraising efforts. Use the buttons below to customize your
									donation page.
								</p>

								<p style={{ marginBottom: "15px" }}>
									Should you have any questions, please contact{" "}
									<a href="mailto:stephanie@valerotexasopen.com">
										Stephanie@ValeroTexasOpen.com
									</a>{" "}
									or at 210.345.3839.
								</p>

								<ContactsCallout />

								<div className="url-container">
									<button
										type="button"
										className="naked"
										title={
											names.copied
												? "Copied to clipboard"
												: "Copy Url to clipboard"
										}
										onClick={() =>
											handleCopy(
												`https://friends.championsforecharity.org/${data.code}`,
											)
										}
									>
										{names.copied ? (
											<i className="fa fa-check fa-lg success"></i>
										) : (
											<i className="fa fa-clone fa-lg"></i>
										)}
									</button>
									<InputReadOnly
										label="Your Fundraising Url & Social Sharing"
										reqd={false}
										value={`https://friends.championsforecharity.org/${data.code}`}
									/>
								</div>

								<div className="social-container">
									<a
										href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
											`https://friends.championsforecharity.org/${data.code}`,
										)}`}
										className="facebook"
										target="_blank"
										rel="noopener noreferrer"
										title="Share to Facebook"
									>
										<i className="fa fa-facebook-square fa-2x"></i>
									</a>

									<a
										href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
											`https://friends.championsforecharity.org/${data.code}`,
										)}&text=${encodeURIComponent(
											`Help my fundraiser efforts for ${data.charity}`,
										)}`}
										className="twitter"
										target="_blank"
										rel="noopener noreferrer"
										title="Share to Twitter"
									>
										<i className="fa fa-twitter-square fa-2x"></i>
									</a>

									<a
										href={`https://friends.championsforecharity.org/${data.code}`}
										className="share"
										target="_blank"
										rel="noopener noreferrer"
										title="Share Url"
									>
										<i className="fa fa-share-square fa-2x"></i>
									</a>
								</div>
							</div>

							<div className="right">
								<div className="logo-container">
									<img src={data.logo} alt={`${data.charity} Logo`} />
								</div>

								<button
									type="button"
									className="btn-alt"
									onClick={() => handleSignout()}
								>
									Sign Out
								</button>
							</div>
						</div>
						<>
							<div className="forms-grid">
								{[
									{
										id: 1,
										name: "Fundraising Story & Goal",
									},
									{
										id: 2,
										name: "Photo & Video",
									},
									{
										id: 3,
										name: "Your Donors",
									},
									{
										id: 4,
										name: "Thank a Donor",
									},
								].map((item, index) => {
									return (
										<button
											key={index}
											type="button"
											className={
												item.id === names.form
													? "btn btn-primary"
													: "btn btn-default"
											}
											onClick={(e) => {
												handleUpdate("form", item.id);
											}}
										>
											{item.name}
										</button>
									);
								})}
							</div>

							{names.form === 1 && <Form1 update={handleUpdate} />}
							{names.form === 2 && <Form2 update={handleUpdate} />}
							{names.form === 3 && <Form3 update={handleUpdate} />}
							{names.form === 4 && <Form4 update={handleUpdate} />}

							<div className="goals-container">
								<h3>Fundraising Goal</h3>

								<div
									style={{
										background: `linear-gradient(to right, #ebf5fa ${data.percent}, 0%, #ffffff ${data.remainder})`,
										height: "35px",
										border: "1px solid #d3e9f3",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<b style={{ color: "#007cba", fontSize: "1.1rem" }}>
										{data.percent}
									</b>
								</div>

								<div
									style={{
										marginTop: "15px",
										textAlign: "center",
										fontSize: "1.25rem",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<b>{data.number}</b>
									<span
										style={{
											paddingLeft: "7.5px",
											paddingRight: "7.5px",
											paddingBottom: "2px",
											fontSize: "1.05rem",
										}}
									>
										{parseInt(data.number, 10) === 1
											? "donor has contributed"
											: "donors have contributed"}
									</span>
									<b>{fmtCurrency(data.pledged / 100)}</b>
									<span
										style={{
											paddingLeft: "7.5px",
											paddingRight: "7.5px",
											fontSize: "1.05rem",
											paddingBottom: "2px",
										}}
									>
										towards your
									</span>
									<b>{fmtCurrency(data.goal / 100, 0)}</b>
									<span
										style={{
											paddingLeft: "7.5px",
											fontSize: "1.05rem",
											paddingBottom: "2px",
										}}
									>
										goal
									</span>
								</div>
							</div>
						</>
					</>
				)}
			</>
		</div>
	);
};

export default FriendsDash;
